"use strict";

//import { registerDecorator, ValidationOptions, ValidationArguments } from 'class-validator'
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidEmail = isValidEmail;
/**
 * Validates that a string is a valid email address
 * @param validationOptions Additional validation options
 */
/*
export function IsValidEmail(validationOptions?: ValidationOptions) {
  return function (object: Object, propertyName: string) {
    registerDecorator({
      name: 'isValidEmail',
      target: object.constructor,
      propertyName: propertyName,
      options: {
        message: 'Please provide a valid email address',
        ...validationOptions,
      },
      validator: {
        validate(value: any, args: ValidationArguments) {
          if (typeof value !== 'string') {
            return false
          }
          // RFC 5322 compliant email regex
          return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(
            value
          )
        },
      },
    })
  }
}
*/
/**
 * Validates that a string is a valid email address
 * @param email The email address to validate
 * @returns true if the email address is valid, false otherwise
 */
function isValidEmail(email) {
  if (typeof email !== 'string') {
    return false;
  }
  // RFC 5322 compliant email regex
  return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(email);
}
//# sourceMappingURL=email.validator.js.map